import { DEMPOGRAPHIC } from "../../constants/action-types";
const initialState = {
    ageRange: [],
    childrenInHouseHold: [],
    maritalStatus: [],
    incomeRange: [],
    occupation: [],
    education: [],
    gender: []
}

const DemographicReducer = (state = initialState, action) => {
    switch (action.type) {
        case DEMPOGRAPHIC.UPDATE_AGE_RANGE: {
            return Object.assign({}, state, {
                ageRange: action.payload
            });

        }
        case DEMPOGRAPHIC.UPDATE_CHILDREN_IN_HOUSEHOLD: {
            return Object.assign({}, state, {
                childrenInHouseHold: action.payload
            });

        }
        case DEMPOGRAPHIC.UPDATE_MARITAL_STATUS: {
            return Object.assign({}, state, {
                maritalStatus: action.payload
            });

        }
        case DEMPOGRAPHIC.UPDATE_INCOME_RANGE: {
            return Object.assign({}, state, {
                incomeRange: action.payload
            });

        }
        case DEMPOGRAPHIC.UPDATE_OCUPATION: {
            return Object.assign({}, state, {
                occupation: action.payload
            });

        }
        case DEMPOGRAPHIC.UPDATE_EDUCATION: {
            return Object.assign({}, state, {
                education: action.payload
            });

        }
        case DEMPOGRAPHIC.UPDATE_GENDER: {
            return Object.assign({}, state, {
                gender: action.payload
            });

        }

        default:
            return state
    }

}

export default DemographicReducer